import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.app-separator-default { background-color: ${dt('appSeparator.background')}; }
.app-separator-platinum { background-color: ${dt('appSeparator.platinum.background')}; }
.app-separator-neutral { background-color: ${dt('appSeparator.neutral.background')}; }
`;
